const hasValue = (value: unknown): boolean => value !== undefined && value !== null && value !== ''

const isNonEmptyListEntry = (item: unknown): boolean => {
  if (item !== null && typeof item === 'object') {
    return Object.values(item).some(hasValue)
  }
  return hasValue(item)
}

/**
 * Drops array entries the user never filled in, so an untouched row in an editable list is not
 * submitted as an empty item. Non-array values pass through unchanged.
 */
export const stripEmptyListEntries = (values: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {}
  for (const [key, value] of Object.entries(values)) {
    result[key] = Array.isArray(value) ? value.filter(isNonEmptyListEntry) : value
  }
  return result
}
